/**
 * Whether the sidebar is collapsed to a rail of icons, and how that choice survives a reload
 * (docs/13-tasks/01-ui-chrome.md#18 §4). Pure verdicts here; `hooks/useNavRail.ts` does the storage (rule S1).
 *
 * The default is EXPANDED: a reader who has never touched the button must see the labels. Only a
 * value this file wrote counts — anything else in storage (an old key, a hand-edited string,
 * `null` because storage is empty) reads back as the default rather than as a crash.
 */
export const NAV_RAIL_STORAGE_KEY = 'thongketau.navRail';

/** `true` = collapsed to the icon rail. */
export type NavRail = boolean;

export const DEFAULT_NAV_RAIL: NavRail = false;

/** What a stored value means. */
export function navRailFromStorage(stored: string | null): NavRail {
  if (stored === 'rail') return true;
  if (stored === 'full') return false;
  return DEFAULT_NAV_RAIL;
}

/** What to put in storage — the same two words this file reads back. */
export function navRailToStorage(rail: NavRail): string {
  return rail ? 'rail' : 'full';
}

/**
 * The value of `data-nav` on the shell. The CSS keys every collapsed measurement off this one
 * attribute, so the component never has to compute a width.
 */
export function navRailAttribute(rail: NavRail): 'rail' | 'full' {
  return rail ? 'rail' : 'full';
}

/** What the collapse button says it will do — the button names the ACTION, not the state. */
export function navRailActionLabel(rail: NavRail): string {
  return rail ? 'Mở rộng điều hướng' : 'Thu gọn điều hướng';
}
